import type { OnDestroy } from '@angular/core';
import { Injectable } from '@angular/core';

import { EWebSocketMessage } from '@rpgc-ai/shared-interfaces/enums/websocket.enum';
import type { IChatWorkflowStorageUpdatedMessage } from '@rpgc-ai/shared-interfaces/interfaces/websocket.interface';

import { WebsocketService } from '../websocket/websocket.service';

/**
 * Phase 129 R-04 — Subscriber for State-Sync Bridge events.
 * Backend emits `chat_workflow_storage_updated` whenever ChatWorkflow.storage
 * is mutated server-side; consumers (GameRuntimeComponent) read `message()`
 * via Angular `effect()` and route the payload into
 * `GameHandle.applyStateSync({ storageData })`.
 */
@Injectable({ providedIn: 'root' })
export class ChatWorkflowStorageUpdatedService
  extends WebsocketService<IChatWorkflowStorageUpdatedMessage>
  implements OnDestroy
{
  override readonly eventKey = EWebSocketMessage.CHAT_WORKFLOW_STORAGE_UPDATED;
}
